import styles from 'styles/modules/newsAlert/Detail.module.scss';
import DateProgress from 'components/DateProgress';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { getDateDifference } from 'helpers/getDateDifference';

const CountDown = ({ close, status, deadline, createdAt, isFTEditor }) => {
    const [timeLeft, setTimeLeft] = useState(getDateDifference(deadline));
    // close alert automatically
    useEffect(() => {
        if (
            timeLeft.day === 0 &&
            timeLeft.hour === 0 &&
            timeLeft.minute === 0 &&
            timeLeft.second === 0
        ) {
            close();
        }
    }, [timeLeft]);

    let interval;
    useEffect(() => {
        clearInterval(interval);

        if (!deadline || status !== 'active') {
            return;
        }

        interval = setInterval(() => {
            setTimeLeft(getDateDifference(deadline));
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [deadline, status]);
    return (
        <div
            className={[
                styles.timer,
                status === 'active' ? styles.timerActive : '',
            ].join(' ')}
        >
            {status === 'active' ? (
                <>
                    <DateProgress
                        deadline={deadline}
                        createdAt={createdAt}
                        height={7}
                        isFTEditor={isFTEditor}
                    />
                    <div className={styles.dateWrapper}>
                        <p>
                            <b>
                                {timeLeft?.day !== 0 ? timeLeft?.day + 'D' : ''}{' '}
                                {timeLeft?.hour !== 0
                                    ? timeLeft?.hour + 'H'
                                    : ''}{' '}
                                {timeLeft?.minute !== 0
                                    ? timeLeft?.minute + 'M'
                                    : ''}{' '}
                                {timeLeft?.day === 0
                                    ? timeLeft?.second + 'S'
                                    : ''}{' '}
                            </b>
                        </p>
                        <span>until end</span>
                    </div>
                </>
            ) : (
                <div>
                    <p>
                        ended{' '}
                        {moment(new Date(deadline)).format('DD. MMMM YYYY')}
                    </p>
                </div>
            )}
        </div>
    );
};
export default CountDown;
